import config from "@/lib/config";
import { maskTargetKeys, metaSchemas, userRating } from "@/lib/constants";
import getRemoteIpAddress from "@/lib/getRemoteIpAddress";
import { RESTDataSource } from "@apollo/datasource-rest";
import { v4 as uuidv4 } from "uuid";

function recurciveMask(data = {}) {
  const copiedData = JSON.parse(JSON.stringify(data));
  function mask(key, value) {
    if (Array.isArray(value)) {
      return value.map((v) => mask(key, v));
    } else if (typeof value === "object") {
      return recurciveMask(value);
    } else if (typeof value === "string") {
      if (maskTargetKeys.includes(key)) {
        return value.replace(/./g, "*");
      } else {
        return value;
      }
    }
    return value;
  }
  for (const key in copiedData) {
    const value = copiedData[key];
    copiedData[key] = mask(key, value);
  }
  return copiedData;
}

class IdcAPI extends RESTDataSource {
  baseURL = config.idc.domain;

  constructor(options) {
    super(options);
    this.context = options;
  }

  get config() {
    return {
      service: config.service,
      deviceCode: this.context.req.deviceCode,
      appId: config.appId["vod"],
      storeId: config.storeId["vod"],
      valuePlanId: config.valuePlanId["vod"],
      userId: this.context.req?.userToken?.id,
      profileId: this.context.req?.userToken?.currentProfile,
      rating: this.context.req?.userToken?.rating,
    };
  }

  isMaybeLoggedIn() {
    return !!this.context.req?.idcToken?.accessToken;
  }

  willSendRequest(_path, request) {
    request.headers["Content-Type"] = "application/x-www-form-urlencoded";
    // IPアドレスをforward
    const remoteIp = getRemoteIpAddress(this.context.req);
    request.headers["X-Forwarded-For"] = remoteIp;
    // UAをプロキシする
    request.headers[
      "User-Agent"
    ] = `${this.context.req?.deviceInfo?.ua} spooxweb`;

    if (
      _path === "/idcs/sso/TokenEndpoint" ||
      _path === "/idcs/sso/RefreshToken"
    ) {
      const accessToken = Buffer.from(
        `${config.idc.clientId}:${config.idc.clientSecret}`
      ).toString("base64");
      request.headers["Authorization"] = `Basic ${accessToken}`;
    } else {
      const accessToken = this.context.req?.idcToken?.accessToken;
      request.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    const requestParams = request.params || null;
    const operationName = this.context.req?.query?.operationName || "unknown";
    const url = this.context.req?.url || "unknown";

    try {
      // 個人情報をマスクする
      const maskedBody = recurciveMask(request.body);
      const maskedBodyStr = JSON.stringify(maskedBody || null);
      console.log(
        `[IDC][REQUEST INFO] Method: ${request.method}, Path: ${_path}, Params: ${requestParams},  Body: ${maskedBodyStr}, OperationName: ${operationName}, URL: ${url} Authorization: ${request.headers["Authorization"]} ContentType: ${request.headers["Content-Type"]}`
      );
    } catch (e) {
      // 万が一エラーになってもサービスを止めないようにエラーを潰す
      console.log(e);
    }
  }

  async didReceiveResponse(response, request) {
    const requestId = request.headers["X-Spoox-Web-Idc-Request-Id"];
    const responseBody = await super.didReceiveResponse(response, request);
    console.log(
      `[${requestId}][IDC][RESPONSE INFO] Status: ${response.status}`
    );
    return responseBody;
  }
}
export default IdcAPI;
